<form [formGroup]="filterFormGroup">
    <div class="filter-elements">
        <!-- Netzbetreibername -->
        @if (showWestnetzFilter) {
            <mat-form-field>
                <mat-label>Netzbetreibername</mat-label>
                <input matInput
                       [matAutocomplete]="netzbetreiber"
                       data-qa="filter-netzbetreiber-name"
                       formControlName="netzbetreiber">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
                <mat-autocomplete #netzbetreiber="matAutocomplete"
                                  panelWidth="200">
                    @for (netzbetreiberName of filteredNetzbetreiber$ | async; track netzbetreiberName) {
                        <mat-option
                            [value]="netzbetreiberName">
                            {{ netzbetreiberName }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }

        <!-- Teilgebiet -->
        @if (showWestnetzFilter) {
            <mat-form-field>
                <mat-label>Teilgebiet</mat-label>
                <input matInput
                       name="netzbetreiberTeilgebiet"
                       [matAutocomplete]="netzbetreiberTeilgebiet"
                       data-qa="filter-netzbetreiber-teilgebiet"
                       formControlName="netzbetreiberTeilgebiet">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
                <mat-autocomplete #netzbetreiberTeilgebiet="matAutocomplete"
                                  panelWidth="200">
                    @for (teilgebiet of filteredNetzbetreiberTeilgebiet$ | async; track teilgebiet) {
                        <mat-option
                            [value]="teilgebiet">
                            {{ teilgebiet }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }

        <!-- Westnetz Id -->
        <mat-form-field>
            <mat-label>Westnetz-ID</mat-label>
            <input matInput
                   [matAutocomplete]="westnetzId"
                   data-qa="filter-westnetz-id"
                   formControlName="westnetzId">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #westnetzId="matAutocomplete"
                              panelWidth="200">
                @for (id of filteredWestnetzId$ | async; track id) {
                    <mat-option
                        [value]="id">
                        <div class="anlagentype-option">
                            <span>{{ id }}</span>
                        </div>
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Ortsname -->
        <mat-form-field>
            <mat-label>Ortsname</mat-label>
            <input matInput
                   [matAutocomplete]="ortsname"
                   data-qa="filter-ortsname"
                   formControlName="ortsname">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #ortsname="matAutocomplete"
                              panelWidth="200">
                @for (ortsname of filteredOrtsnamen$ | async; track ortsname) {
                    <mat-option [value]="ortsname">
                        {{ ortsname }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Status -->
        <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select
                data-qa="filter-status"
                formControlName="status">
                <mat-option [value]="true">Gültig</mat-option>
                <mat-option [value]="false">Ungültig</mat-option>
            </mat-select>
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
        </mat-form-field>

        <!-- Stationsname -->
        <mat-form-field>
            <mat-label>Stationsname</mat-label>
            <input matInput
                   name="stationsname"
                   [matAutocomplete]="stationsname"
                   data-qa="filter-stationsname"
                   formControlName="stationsname">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #stationsname="matAutocomplete"
                              panelWidth="200">
                @for (stationsname of filteredStationsnamen$ | async; track stationsname) {
                    <mat-option [value]="stationsname">
                        {{ stationsname }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Primärenergieträger Anlagentyp -->
        <mat-form-field>
            <mat-label>Primärenergieträger</mat-label>
            <input matInput
                   [matAutocomplete]="auto"
                   data-qa="filter-anlagentyp"
                   formControlName="anlagentype">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #auto="matAutocomplete"
                              panelWidth="200">
                @for (anlagentype of filteredAnlagentype$ | async; track anlagentype.nummer) {
                    <mat-option
                        [value]="anlagentype.abkuerzung">
                        <div class="anlagentype-option">
                <span
                    [className]="'anlagentype-icon bg-'+anlagentypColorService.getColorNameForAnlagentyp(anlagentype)">
                  <img
                      [src]="ASSET_URL + '/innogy-icons/Negative/'+anlagentypIconService.getIconNameForAnlagentyp(anlagentype)"
                      height="25">
                </span>
                            <span>{{ anlagentype.abkuerzung }} | {{ anlagentype.name }}</span>
                        </div>
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Installierte Leistung Min</mat-label>
            <input matInput
                   formControlName="installierteLeistungMin"
                   type="number"
                   data-qa="filter-installierte-leistung-min">
            <span matSuffix class="kw-suffix">kW</span>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Installierte Leistung Max</mat-label>
            <input matInput
                   formControlName="installierteLeistungMax"
                   type="number"
                   data-qa="filter-installierte-leistung-max">
            <span matSuffix class="kw-suffix">kW</span>
        </mat-form-field>

        @if (showWestnetzFilter) {
            <mat-button-toggle-group
                name="leitstellenRegion"
                multiple="true"
                formControlName="leitstellenRegion"
                appearance="standard"
            >
                <mat-button-toggle value="WNN">Nord</mat-button-toggle>
                <mat-button-toggle value="WNS">Süd</mat-button-toggle>
            </mat-button-toggle-group>
        }

    </div>

    <div class="reset-button-container">
        <button matButton="filled" type="reset">
            <mat-icon>autorenew</mat-icon>
            Zurücksetzen
        </button>
        @if (isWetznetzUser()) {
            <button id="exportCsvButton" matButton="outlined"
                    (click)="exportErzeugungsanlagenCSV()">
                <mat-icon>file_download</mat-icon>
                CSV exportieren
            </button>
        }
    </div>
</form>

